import wishTmpl from '@page/common/js/template/wishTmpl';
import axios from 'axios';

const wishBtn = {
  template: wishTmpl,
  data: function () {
    return {
      isRunning: false,
    };
  },
  props: ['wishactive', 'custommarketid', 'styletype'],
  methods: {
    addToWish: function () {
      if (this.isRunning) return;
      this.isRunning = true;

      axios
        .post(API_URL.FAVORITE, {
          CustomMarketID: this.custommarketid,
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.wishactive = 'True';
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('Please login.');
          } else {
            AlertDialog.alert('The server is currently busy. Please try again later.');
          }
          this.isRunning = false;
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
    removeWish: function () {
      if (this.isRunning) return;
      this.isRunning = true;

      axios
        .delete(API_URL.FAVORITE, {
          data: { CustomMarketID: this.custommarketid },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.wishactive = 'False';
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('Please login.');
          } else {
            AlertDialog.alert('The server is currently busy. Please try again later.');
          }
          this.isRunning = false;
        })
        .catch((err) => {
          AlertDialog.alert(err);
        });
    },
  },
};

export default wishBtn;
